import {Outlet, createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../messages/routes.messages";

/**
 * Users section layout route — common ancestor for both the user list page
 * and all user detail / tab pages.
 *
 * Carrying breadcrumb metadata here (rather than on the index route) ensures that
 * the users section always appears as the first breadcrumb segment regardless of
 * which child route is active, because this layout is always present in the match chain.
 */
export const Route = createFileRoute("/_app/admin/users")({
  component: () => <Outlet />,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.users,
      moduleDescriptor: routeMessages.admin,
      nav: {order: 2, visible: true},
    },
  },
});
